import React from 'react';
import cn from 'classnames';
import './Spinner.css';

export type SpinnerProps = React.HTMLAttributes<HTMLDivElement> & {
    /**
     * Define a delay in milliseconds after which the spinner is shown.
     * Default value is `500`ms
     */
    delay?: number;
    /** Define a text that will be displayed below spinner */
    label?: string;
};

export const Spinner = React.forwardRef(function Spinner(props: SpinnerProps, ref: React.Ref<HTMLDivElement>) {
    const { delay = 500, label, ...otherProps } = props;
    const [visible, setVisibility] = React.useState(!delay);

    React.useEffect(() => {
        let timeout: number;

        if (delay) {
            timeout = window.setTimeout(() => setVisibility(true), delay);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [delay]);

    if (!visible) {
        return null;
    }

    const className = cn('yt-spinner', otherProps.className);

    return (
        <div {...otherProps} className={className} ref={ref}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45"></circle>
            </svg>
            {label && <span>{label}</span>}
        </div>
    );
});
